import { api } from "../api";

/**
 * findAllDriversExportResponse - Function that finds on database all drivers by department and status and then exports in a PDF/XSLX file  
 * /drivers/{customerId}/{departmentId}/{status}/{exportType}/export   
 * method GET  
 * @async-function
 */
const findAllDriversExportResponse = async (token: string, customerId: number ,departmentId: number, status: string, exportType: string, ignoreDepartments: boolean = false, simpleXlsxExport = false) => {
    const response = await api.get(
        `/drivers/${customerId}/${departmentId}/${status}/${exportType}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllDriversExportResponse;